import z from 'zod'

export const PaymentsSearchSchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).catch(50),
    offset: z.coerce
        .number()
        .int()
        .min(0)
        .max(Number.MAX_SAFE_INTEGER - 100)
        .catch(0),
})
